import types from './types';
import { cdnHostCheck } from '@kk-activity-factory/utils';

export default {
    [types.SET_HOST](state, host) {
        state.host = host;
    },
    [types.LOGIN](state, user) {
        Object.assign(state.user, user);
    },
    [types.SET_PAGE_DATA](state, payload) {
        state.pageData = cdnHostCheck(payload);
    },
    [types.SET_SAFE_TOP_AND_BOTTOM](state, payload) {
        state.safeTop = payload.top;
        state.safeBottom = payload.bottom;
    },
    [types.SET_PV_STATUS](state, payload) {
        state.hasUploadPV = payload.hasUploadPV;
        state.isFirstTime = payload.isFirstTime;
        state.isCurrentDayFirstVisit = payload.isCurrentDayFirstVisit;
        state.userAvatar = payload.userAvatar;
    },
    [types.SET_APP_VERSION](state, payload) {
        state.appVersion = payload;
    },
    [types.SET_COMPONENT_LIST](state, payload) {
        state.componentConfigList = payload;
    },
    [types.SET_CURRENT_PAGE_STATUS](state, payload) {
        Object.assign(state.pageStatus, payload);
    },
    [types.SET_CLOSE_STAY_MODULE](state) {
        state.hasCloseStayModule = true;
    },
    [types.SET_TOP_BAR_SHARE_BUTTON_DATA](state, payload) {
        state.topBarShareButtonData = payload;
    },
    [types.SET_FIND_TAB_TRANSLATE](state, payload) {
        state.findTabTranslate = payload;
    },
    [types.SET_NEED_FIRST_SHOW_TITLE_IMG](state, payload) {
        state.shouFirstShowTitleImg = payload;
    },
    [types.SET_HAS_FIRST_SHOW_TITLE_IMG](state, payload) {
        state.hasFirstShowTitleImg = payload;
    },
    [types.SET_TITLE_IMG_MODULE_PROCESS_FINISHED](state) {
        state.titleImgModuleProcessFinished = true;
    },
    [types.SET_ALLOW_REPEAT_TASK_AUTO_OBTAIN_PRIZE](state) {
        state.allowRepetTaskAutoObtainPrize = true;
    },
    [types.SET_FINDLIKE_CONTAINER_HAS_VISIBLE](state) {
        state.findLikeContainerHasVisible = true;
    },
    [types.SET_PRIORITY_PROCESSING_START](state) {
        state.priorityProcessingStart = true;
    },
};
